<app-loader [isInline]="true" [hasTransparency]="true" *ngIf="isSaving" ></app-loader>
<vtr-digital-log #digitalLog
	[offline]="!isOnline"
	[formJsonSchema]="formJsonSchema" 
	[formLookups]="formLookups" 
	[formData]="formData" 
	[job]="jobDetails"
	[customDate]="customDate"
	[formTimeSlots]="formTimeSlots" 
	[offlineRanges]="offlineRanges"
	[fieldDocuments]="fieldDocuments"
	[isFieldDocumentsLoading]="isFieldDocumentsLoading"
	[currentHistoricalValues]="currentHistoricalValues"
	[externalCloseEventEmitter]="externalCloseEventEmitter"
	[binderInfo]="binderInfo"
	[isNotificationSent]="isNotificationSent"
	(onHistoricalValuesRequest)="getHistoricalValues($event)"
	(onHistoricalValueChange)="updateHistoricalValues($event)"
	(onTimeSlotChange)="saveTimeSlot($event)" 
	(onSave)="save($event)"
	(onClose)="close()"
	(onOfflineRangeChange)="changeOfflineRanges($event)"
	(onDisableForm)="disableForm($event)"
	(onDeleteForm)="deleteForm()"
	(onRedirectToBinder)="redirectToBinder()"
	(onPhotosClicked)="goToPhotos($event)"
	(onNotifyManagementClick)="notifyBinderManagement()"
	(onCompletePendingForms)="completePendingOnDemandForms($event)"
	(onUploadFieldDocument)="uploadFieldDocument($event)"
	(onRemoveFieldDocument)="removeFieldDocument($event)"
	(onEditFieldDocument)="editFieldDocument($event)"
	(onFieldDocumentListOrderChange)="changeFieldDocumentListOrder($event)"
></vtr-digital-log>

<!-- load before going offline -->
<generic-modal #offlineDataSavedModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">			
			No Internet Connection
		</div>
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container">			
			<ng-container>
				<mat-icon style="width: 44px; height: 44px; color: rgb(248, 87, 87);" class="svg-icon" [svgIcon]="'signal_disconnected'"></mat-icon>
				<p>Please make sure you have an active internet connection in order to save any changes</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="closeOfflineModal()"
			>Ok</button>		
	</ng-template>
</generic-modal>

<generic-modal #unsavedOfflineDataModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">			
			Unsaved Data Detected <br/>
			<span style="color: gray; font-size: 12px; font-style: italic;">created on: <b>{{unsavedOfflineData.updatedOn}}</b></span>
		</div>
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container">			
			<ng-container>
				<mat-icon style="width: 44px; height: 44px; color: green;" class="svg-icon" [svgIcon]="'signal_disconnected'"></mat-icon>
				<p>
					Your have unsaved changes for this form locally.					
				</p>
				<p style="font-weight: bold;">Do you want to apply them?</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="applyOfflineData()"
			>Yes</button>
		<button mat-flat-button (click)="discardUnsavedOfflineData()"
			>No, Discard</button>
	</ng-template>
</generic-modal>

<generic-modal #fieldDocumentErrorModal [hideOnBackdropClick]="true" [overlayClass]="'field-document-error-modal'">	
	<ng-template #modalBody>
		<div class="main-container">			
			<ng-container>				
				<p>Unable to update the attachment. <br/> Please try again!</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="closeFieldDocumentErrorModal()">Ok</button>		
	</ng-template>
</generic-modal>
<generic-modal #offlineDataSavedModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">			
			No Internet Connection
		</div>
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container">			
			<ng-container>
				<mat-icon style="width: 44px; height: 44px; color: rgb(248, 87, 87);" class="svg-icon" [svgIcon]="'signal_disconnected'"></mat-icon>
				<p>Please make sure you have an active internet connection in order to save any changes</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="closeOfflineModal()"
			>Ok</button>		
	</ng-template>
</generic-modal>

<generic-modal #unsavedOfflineDataModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">			
			Unsaved Data Detected <br/>
			<span style="color: gray; font-size: 12px; font-style: italic;">created on: <b>{{unsavedOfflineData.updatedOn}}</b></span>
		</div>
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container">			
			<ng-container>
				<mat-icon style="width: 44px; height: 44px; color: green;" class="svg-icon" [svgIcon]="'signal_disconnected'"></mat-icon>
				<p>
					Your have unsaved changes for this form locally.					
				</p>
				<p style="font-weight: bold;">Do you want to apply them?</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="applyOfflineData()"
			>Yes</button>
		<button mat-flat-button (click)="discardUnsavedOfflineData()"
			>No, Discard</button>
	</ng-template>
</generic-modal>

<generic-modal #futureLogDateConfirmationModal [hideOnBackdropClick]="true" [overlayClass]="'field-document-error-modal'">
	<ng-template #modalHeading let-data="data">
		<div class="future-log-date-heading">
			<div>
				Future Log Date
			</div>
			<div class="future-log-date-subheading">
				<hr />
			</div>
		</div>
	</ng-template>
	<ng-template #modalBody>
		<div class="main-container">
			<ng-container>
				<p>You are completing a form that has a future date.</p>
				<p>Do you want to update the Log Date to current date or keep it as it is?</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="updateLogDateToCurrent(data)">Update Log Date</button>
		<button mat-flat-button (click)="closeFutureLogDateConfirmationModal(data)">Keep Current Log Date</button>
	</ng-template>
</generic-modal>


<input type="file" name="photos-input" hidden #photoPicker 
	(change)="onFieldPhotoChanged($event.target.files)"
	accept=".jpg, .jpeg, .png" 
/>

<!-- FIELD PHOTO UPLOADER -->
<generic-modal #addPhotoModal class="add-field-photo-modal" [hideOnBackdropClick]="false">
	<ng-template #modalHeading>		
		<div class="photo-picker-header">
			<span class="field-name">{{targetPhotoGallery.field?.name}} - Photo</span>
			<span class="field-parent">{{targetPhotoGallery.field?.parentFieldName}}</span>
		</div>				
	</ng-template>
	<ng-template #modalBody>
				
		<form class="main-form" [formGroup]="fieldPhotoForm" @fadeIn>
			<div class="photo-wrapper">
				<img *ngIf="fieldPhotoForm.get('photo').value" [src]="getPhotoPreviewUrl()" [alt]="getPhotoPreviewAltName()" />
				<mat-icon *ngIf="!fieldPhotoForm.get('photo').value"
					svgIcon="site_note_deficiency_add_photo" 
					style="width: 300px; height: 300px; color: lightgray;"></mat-icon>						
			</div>			
			<div class="photo-notes">
				<mat-form-field>
					<mat-label>Notes</mat-label>
					<textarea rows="5" matInput formControlName="note"
						placeholder="Enter notes here..."></textarea>
				</mat-form-field>
			</div>
		</form>
		<app-loader [isInline]="true" [hasTransparency]="true" [loaderMessage]="'Saving photo...'" *ngIf="isPhotoSaving" ></app-loader>
		<p *ngIf="!!addPhotoMessage" class="add-photo-warning">{{addPhotoMessage}}</p>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-raised-button class="secondary" type="button" (click)="addPhotoModal.hide()">Cancel</button>
		<button mat-raised-button type="button" class="primary" [disabled]="!fieldPhotoForm.valid || isPhotoSaving"
			(click)="onSavePhoto()">Save</button>
	</ng-template>
</generic-modal>